import { render, staticRenderFns } from "./invest_bank.vue?vue&type=template&id=5e5318f4&scoped=true&"
import script from "./invest_bank.vue?vue&type=script&lang=js&"
export * from "./invest_bank.vue?vue&type=script&lang=js&"
import style0 from "./invest_bank.vue?vue&type=style&index=0&id=5e5318f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5318f4",
  null
  
)

export default component.exports